/**
 * Where each dashboard card sends the reader.
 *
 * WHY THESE ARE BUILT FROM THE FILTER HELPERS and not written as strings. The
 * cards used to link to `/requirements?state=unresolved` and its two siblings,
 * and issue #35 removed the `state` parameter without touching them: nothing
 * read it any more, so every card opened the full unfiltered list (issue #72).
 * A hand-written query string is a link that can outlive the parameter it
 * points at and nothing notices. Building each URL with `writeQuick` /
 * `writeFilterModel` - the functions the Requirements screen READS with - means
 * the link and the screen cannot drift apart, and dashboardLinks.test.ts reads
 * every link back through those readers to prove it.
 *
 * The three shapes the old `state` menu offered, and what replaced each (see
 * the header of Requirements.tsx): unresolved is a status quick filter,
 * unverified is the column filter `verified_by` is empty, and orphans are a
 * Findings check, so they go to the Findings group rather than to a list.
 */

import { writeFilterModel } from '../components/entity/rowFilter'
import { writeQuick } from '../components/entity/quickFilter'
import { findingAnchor } from './findings-model'

const NO_PARAMS = new URLSearchParams()

export const dashboardLinks = {
  /** Status tbd, tbr or tbc, as the status quick filter. */
  unresolved: `/requirements?${writeQuick(NO_PARAMS, { status: ['tbd', 'tbr', 'tbc'] })}`,
  /** `verified_by` is empty, as a column filter. */
  unverified: `/requirements?${writeFilterModel(NO_PARAMS, {
    items: [{ field: 'verified_by', operator: 'isEmpty' }],
  })}`,
  /** The orphan group on the Findings screen. */
  orphans: `/findings#${findingAnchor('orphan')}`,
}
